module.exports = __webpack_public_path__ + "img/down_icon.ef8dcdd8.svg";